module.exports = __webpack_public_path__ + "static/media/raindrops-alt.e9dba0cd.svg";